import { createContext, useContext, useState } from "react";

const EmailBuilderContext = createContext({
  formData: null,
  setFormData: () => null,
});

const EmailBuilderProvider = ({ children }) => {
  const [formData, setFormData] = useState(null);

  return (
    <EmailBuilderContext.Provider value={{ formData, setFormData }}>
      {children}
    </EmailBuilderContext.Provider>
  );
};

export default EmailBuilderContext;

const useEmailBuilderContext = () => {
  const context = useContext(EmailBuilderContext);
  if (context === undefined) {
    throw new Error(
      "EmailBuilderContext must be used within a EmailBuilderProvider"
    );
  }

  return context;
};
export { EmailBuilderProvider, useEmailBuilderContext };
